const _excluded = ["envelope"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as uuidV4 } from 'uuid';
import notificationConstants from '../constants/notificationConstants';
import { parseErrorEnvelope } from '../utils/errorEnvelope';
const defaultSettings = {
  // show close button unless overridden in notification
  showCloseButton: true,
  // by default, close notifications after 5s unless otherwise specified
  autoClose: 5000
};

// must run function fresh every time to get a new uuid
const defaultContent = () => ({
  // id comes in before options so passed in IDs take precedent
  id: uuidV4().toUpperCase()
});
const addBlockingNotification = (content, settings = {}) => ({
  content,
  settings,
  type: notificationConstants.CREATE_MODAL
});
const addNotification = (content, settings = {}) => ({
  content,
  settings,
  type: notificationConstants.CREATE
});
const block = (content, settings) => addBlockingNotification(_objectSpread(_objectSpread({}, defaultContent()), content), _objectSpread(_objectSpread({}, defaultSettings), settings));
const dismiss = id => {
  if (id !== undefined) {
    return {
      id,
      type: notificationConstants.DISMISS
    };
  }
  return {
    type: notificationConstants.DISMISS
  };
};
const error = (content, settings = {}) => {
  const base = _objectSpread(_objectSpread({}, defaultContent()), {}, {
    headerMessage: 'Error',
    messageType: 'error'
  });
  if (content !== null && content !== void 0 && content.envelope) {
    const {
        envelope
      } = content,
      rest = _objectWithoutProperties(content, _excluded);
    const parsed = parseErrorEnvelope(envelope);
    return addNotification(_objectSpread(_objectSpread(_objectSpread({}, base), rest), {}, {
      message: parsed.message,
      hint: parsed.hint,
      technicalDetail: parsed.technicalDetail,
      reference: parsed.reference,
      errorCode: parsed.errorCode
    }), _objectSpread(_objectSpread({}, defaultSettings), settings));
  }
  return addNotification(_objectSpread(_objectSpread({}, base), content), _objectSpread(_objectSpread({}, defaultSettings), settings));
};
const info = (content, settings = {}) => addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
  messageType: 'info'
}), _objectSpread(_objectSpread({}, defaultSettings), settings));
const save = (content, settings = {}) => addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
  id: notificationConstants.UNSAVED_CHANGES_WARNING,
  messageType: 'save'
}), _objectSpread(_objectSpread({}, defaultSettings), settings));
const success = (content, settings = {}) => addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), {}, {
  // goes first in case things like id are passed in with content
  headerMessage: 'Success'
}, content), {}, {
  messageType: 'success'
}), _objectSpread(_objectSpread({}, defaultSettings), settings));
const upload = (content, settings = {}) => addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), content), {}, {
  messageType: 'upload'
}), _objectSpread(_objectSpread({}, defaultSettings), {}, {
  // show the notifications longer if there were any failures or if there are lots of files
  autoClose: content.failedToUpload && content.failedToUpload.length || content.files.length + content.failedToUpload.length > 22 ? 25000 : 10000
}, settings));
const validationError = (content, settings = {}) => addNotification(_objectSpread(_objectSpread(_objectSpread({}, defaultContent()), {}, {
  // goes first in case things like id are passed in with content
  headerMessage: 'Validation Error'
}, content), {}, {
  messageType: 'error'
}), _objectSpread(_objectSpread({}, defaultSettings), settings));
const actions = {
  block,
  dismiss,
  error,
  info,
  save,
  success,
  upload,
  validationError
};
export default actions;